import { render, staticRenderFns } from "./xiugai.vue?vue&type=template&id=1f8bc850&scoped=true&"
import script from "./xiugai.vue?vue&type=script&lang=js&"
export * from "./xiugai.vue?vue&type=script&lang=js&"
import style0 from "./xiugai.vue?vue&type=style&index=0&id=1f8bc850&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8bc850",
  null
  
)

export default component.exports